// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"146a1627","298":"c5882380","371":"af8ca0b6","584":"9d2e00e5","659":"f09bfa9e","851":"146a1627"}[chunkId] + ".chunk.css";
};